import {
  getRouteWeather as getRouteWeatherApi,
  getAlerts as getAlertsApi,
  getLocationGrid as getLocationGridApi,
  getGridsForecast as getGridsForecastApi,
  // getZonesForecast as getZonesForecastApi,
  getFleetWeatherAlertLocation as getFleetWeatherAlertLocationApi,
} from "@/api/map-weather";
import { localStoreServer } from "@/utils/local-store";
import { updataAlertsActiveList } from "@/views/map/components/map/tools/weather";
const state = {
  namespaced: true,
  state: {
    weatherType: null,
    legendShow: false,
    weatherAlertsList: [],
    weatherAlertsListLoading: false,
    showWeatherAlertDetail: false,
    weatherAlertDetailInfo: {},
    alertsActiveList: [],
    weatherAlertLegendCurrentTime: null,
    currentTimeIsSecondDay: false,
    layerData: null,
    locationInfomation: null,
    radarCloudsList: [],
    weatherAlertLegendCurrentTimeStamp: null,
    getLayerDataTimeStamp: null,
    weatherAlertTypesList: [],
    updateWeatherAlertTimeStamp: new Date().getTime(),
    showWeatherPromotion: false,
    alertsActiveOriginList: [],
    getAlertsActiveListFlag: false,
    legendIsShowOtherType: false,
    legendCheckboxDisabledFlag: true,
    showMapWeatherUpdataTips: false,
    S3ZonesDataIsDownloadComplete: false,
    inBoundsIsDownloadCompleteFlag: false,
    statesInBounds: [],
    weatherAlertCurrentIndex: null,
    cancelWeatherAlertsList: [],
    addCancelWeatherAlertsList: [],
  },
  mutations: {
    SET_WEATHER_TYPE(state, flag) {
      state.weatherType = flag;
    },
    SET_LEGEND_SHOW(state, flag) {
      state.legendShow = flag;
    },
    SET_WEATHER_ALERT_LIST(state, list) {
      state.weatherAlertsList = list;
    },
    SET_WEATHER_ALERT_LIST_LOADING(state, flag) {
      state.weatherAlertsListLoading = flag;
    },
    SET_SHOW_WEATHER_ALERT_DETAIL(state, flag) {
      state.showWeatherAlertDetail = flag;
    },
    SET_WEATHER_ALERT_DETAIL_INFO(state, data) {
      state.weatherAlertDetailInfo = data;
    },
    SET_ALERT_ACTIVE_LIST(state, list) {
      state.alertsActiveList = list;
    },
    SET_ALERT_ACTIVE_ORIGIN_LIST(state, list) {
      state.alertsActiveOriginList = list;
    },
    SET_WEATHER_ALERT_LEGEND_CURRENT_TIME(state, time) {
      state.weatherAlertLegendCurrentTime = time;
    },
    SET_CURRENT_TIME_IS_SECONDDAY(state, flag) {
      state.currentTimeIsSecondDay = flag;
    },
    SET_LAYER_DATA(state, data) {
      state.layerData = data;
    },
    SET_LOCATION_INFOMATION(state, data) {
      state.locationInfomation = data;
    },
    SET_RADAR_CLOUDS_LIST(state, list) {
      state.radarCloudsList = list;
    },
    SET_WEATHER_ALERT_LEGEND_CURRENT_TIMESTAMP(state, date) {
      state.weatherAlertLegendCurrentTimeStamp = date;
    },
    SET_GETLAYERDATA_TIMESTAMP(state, timeStamp) {
      state.getLayerDataTimeStamp = timeStamp;
    },
    SET_WEATHER_ALERT_TYPES_LIST(state, list) {
      state.weatherAlertTypesList = list;
    },
    SET_UPDATE_WEATHER_ALERT_TIMESTAMP(state) {
      state.updateWeatherAlertTimeStamp = new Date().getTime();
    },
    SET_SHOW_WEATHER_PROMOTION(state, flag) {
      state.showWeatherPromotion = flag;
    },
    SET_ALERT_ACTIVE_LIST_FLAG(state, flag) {
      state.getAlertsActiveListFlag = flag;
    },
    SET_LEGEND_IS_SHOW_OTHER_TYPE(state, flag) {
      state.legendIsShowOtherType = flag;
    },
    SET_LEGEND_CHECKBOX_DISABLED_FLAG(state, flag) {
      state.legendCheckboxDisabledFlag = flag;
    },
    SET_SHOW_MAP_WEATHER_UPDATATIPS(state, flag) {
      state.showMapWeatherUpdataTips = flag;
    },
    SET_S3ZONESDATA_IS_DOWNLOAD_COMPLETE(state, flag) {
      state.S3ZonesDataIsDownloadComplete = flag;
    },
    SET_INBOUNDS_IS_DOWNLOAD_COMPLETE_FLAG(state, list) {
      state.inBoundsIsDownloadCompleteFlag = list;
    },
    SET_STATE_INBOUNDS(state, list) {
      state.statesInBounds = list;
    },
    SET_WEATHER_ALERT_CURRENT_INDEX(state, index) {
      state.weatherAlertCurrentIndex = index;
    },
    SET_CANCEL_WEATHER_ALERTS_LIST(state, list) {
      state.cancelWeatherAlertsList = list;
    },
    SET_ADD_CANCEL_WEATHER_ALERTS_LIST(state, list) {
      state.addCancelWeatherAlertsList = list;
    },
  },
  actions: {
    getWeatherAlertsList({ commit }, data) {
      console.log(data);
      let points = [];
      if (data.length) {
        for (let item of data) {
          points.push([item.lat, item.lng]);
        }
      }
      let params = {
        client: "Truckerpath_Command/5.8.0",
        points: points,
      };
      commit("SET_WEATHER_ALERT_LIST_LOADING", true);
      return getRouteWeatherApi(params).then(
        (result) => {
          try {
            if (result.code == 200) {
              commit("SET_WEATHER_ALERT_LIST", result.data.weatherList || []);
              commit("SET_WEATHER_ALERT_LIST_LOADING", false);
              return Promise.resolve(result);
            } else {
              commit("SET_WEATHER_ALERT_LIST_LOADING", false);
              return Promise.reject(result);
            }
          } catch (error) {
            commit("SET_WEATHER_ALERT_LIST_LOADING", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_WEATHER_ALERT_LIST_LOADING", false);
          return Promise.reject(error);
        }
      );
    },
    getAlertsActiveList({ state, commit }) {
      return getAlertsApi().then(
        (result) => {
          let res = result.res.data.data;
          try {
            if (res) {
              commit("SET_ALERT_ACTIVE_ORIGIN_LIST", res || []);
              updataAlertsActiveList(
                state.weatherAlertLegendCurrentTimeStamp
              ) || [];
              commit("SET_ALERT_ACTIVE_LIST_FLAG", false);
              return Promise.resolve(res);
            } else {
              commit("SET_ALERT_ACTIVE_LIST_FLAG", false);
              return Promise.reject(res);
            }
          } catch (error) {
            commit("SET_ALERT_ACTIVE_LIST_FLAG", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_ALERT_ACTIVE_LIST_FLAG", false);
          return Promise.reject(error);
        }
      );
    },
    getLocationInfomation({ commit }, data) {
      return getLocationGridApi({
        latitude: data.latitude,
        longitude: data.longitude,
      }).then(
        (result) => {
          let res = result.res.data.properties;
          commit("SET_LOCATION_INFOMATION", res);
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getFleetWeatherAlertLocation({ state, commit }, stateCode) {
      commit("SET_INBOUNDS_IS_DOWNLOAD_COMPLETE_FLAG", false);
      return getFleetWeatherAlertLocationApi(stateCode).then(
        (result) => {
          try {
            let res = result.res.data;
            localStoreServer._localforageSet("mapWeather" + stateCode, res);
            if (state.statesInBounds.includes(stateCode)) {
              commit("SET_INBOUNDS_IS_DOWNLOAD_COMPLETE_FLAG", true);
            }
            return Promise.resolve(res);
          } catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_WEATHER_ALERT_TYPES_FLAG", false);
          return Promise.reject(error);
        }
      );
    },
    async getLayerData({ commit, dispatch }, data) {
      let res = await dispatch("getLocationInfomation", data);
      // if (data.type === "radarClouds" && res.forecastZone) {
      //   return getZonesForecastApi(res.forecastZone).then(
      //     (result) => {
      //       let res = result.res.data;
      //       try {
      //         if (res) {
      //           commit("SET_RADAR_CLOUDS_LIST", res.features || []);
      //           return Promise.resolve(res);
      //         } else {
      //           return Promise.reject(res);
      //         }
      //       } catch (error) {
      //         return Promise.reject(error);
      //       }
      //     },
      //     (error) => {
      //       return Promise.reject(error);
      //     }
      //   );
      // }
      return getGridsForecastApi({
        gridId: res.gridId,
        gridX: res.gridX,
        gridY: res.gridY,
      }).then(
        (result) => {
          let res = result.res.data;
          try {
            if (res) {
              commit("SET_GETLAYERDATA_TIMESTAMP", new Date().getTime());
              commit("SET_LAYER_DATA", res || {});
              return Promise.resolve(res);
            } else {
              return Promise.reject(res);
            }
          } catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
};

export default state;
